import { useQuery } from "@rocicorp/zero/react";
import { useZero } from "@/hooks/use-zero";
import { useSession } from "@/features/auth/use-session";

/** All collections owned by the signed-in user, newest first. */
export function useMyCollections() {
  const z = useZero();
  const { data: session } = useSession();
  const [data, info] = useQuery(
    z.query.collections
      .where("owner_user_id", "=", session?.user?.id ?? "")
      .orderBy("created_at", "desc"),
  );
  return { collections: data, ...info };
}

/** A single collection by id, or undefined while loading. */
export function useCollection(id: string | undefined) {
  const z = useZero();
  const [data, info] = useQuery(
    id ? z.query.collections.where("id", "=", id).one() : false,
  );
  return { collection: data, ...info };
}
